import Vue from 'vue';
import A from './common/components/A';
import Button from './common/components/Button';
import Form from './common/components/Form';

export const init = () => {
	Vue.component('A', A);
	Vue.component('Button', Button);
	Vue.component('Form', Form);
}

export default {
	init
};